module.exports = __webpack_public_path__ + "static/media/tension_clamp_bolted_type.5ea17521.webp";